import { AsYouType, parsePhoneNumberFromString } from 'libphonenumber-js';

export function isoToFlag(isoCode) {
  if (!isoCode || isoCode.length !== 2) return '';
  return isoCode
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));
}

export function formatAsYouType(value, isoCode) {
  const formatter = new AsYouType(isoCode || 'US');
  return formatter.input(value || '');
}

export function normalizePhoneForSave(rawPhone, phoneCountry) {
  const input = (rawPhone || '').trim();
  const isoCode = (phoneCountry || '').trim().toUpperCase();

  if (!input) return null;

  const phone = input.startsWith('+')
    ? parsePhoneNumberFromString(input)
    : parsePhoneNumberFromString(input, isoCode || undefined);

  if (!phone || !phone.isValid()) {
    return null;
  }

  return phone.number;
}

export function formatPhoneForDisplay(phoneNumber, phoneCountry) {
  if (!phoneNumber) return '';

  try {
    const phone = parsePhoneNumberFromString(
      phoneNumber,
      phoneCountry || undefined
    );
    if (!phone) return phoneNumber;

    return phone.formatNational();
  } catch {
    return phoneNumber;
  }
}
